module.exports = "<div class=\"h7 mt-0 order-summary-count-instructions ut-receipt-displayCountOfItems\">\n    <span class=\"order-summary-count-instructions_items-count\">{{diner.lineCountText}}</span>\n    <span ng-if=\"diner.specialInstructionText\"> - {{diner.specialInstructionText}}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/dinerSummaryCount.html
// module id = 792
// module chunks = 0